import { useState } from 'react';
import { api_updateOrderStatus } from '../../../api/order';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const STATUS = ['active', 'completed', 'canceled'];

const EditOrder = () => {
	const order = useLocation().state;
	const [loading, setLoading] = useState<boolean>(false);
	const [status, setStatus] = useState(order.status || STATUS[0]);
	const navigate = useNavigate();

	const edit = async () => {
		try {
			setLoading(true);
			const payload = {
				status: status,
			};
			console.log(payload.status); // Debugging: Check if payload has status

			const res = await api_updateOrderStatus(order._id, payload);
	 // Debugging: Check the response

			const message = typeof res.message === 'string' ? res.message : 'Success';
			if (res.isSuccess) {
				toast.success(message);
				setTimeout(() => {
					navigate(-1);
				}, 100);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyItems: 'center',
				alignItems: 'center',
				flex: 1,
				padding: '40px',
			}}
		>
			<div className='mb-3'>
				<h3>Edit Order</h3>
			</div>

			<div className='mb-3'>
				<label htmlFor='exampleFormControlInput1' className='form-label'>
					Status
				</label>
				<select
					onChange={(e) => setStatus(e.target.value)}
					className='form-select'
					aria-label='Default select example'
					value={status} // Ensure the select value is set correctly
				>
					<option disabled>Choose Status</option>
					{STATUS.map((i, index) => (
						<option key={index} value={i}>
							{i}
						</option>
					))}
				</select>
			</div>
			<button
				onClick={edit}
				type='button'
				className='btn btn-lg btn-primary'
				disabled={loading}
			>
				{loading ? 'Loading..' : 'Submit'}
			</button>
		</div>
	);
};

export default EditOrder;
